import { render, staticRenderFns } from "./ClosedHoursData.vue?vue&type=template&id=40a012a0&"
import script from "./ClosedHoursData.vue?vue&type=script&lang=js&"
export * from "./ClosedHoursData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports